<template>
    <div>
        <el-cascader :options="city" v-model="hospAddArr" @active-item-change="handleChange" :props="propAdd"></el-cascader>
    </div>
</template>

<script>
export default {
    data(){
        return{
            propAdd:{
                value: 'value',
                children: 'cities'
            },
            city:[],//地区数据
            hospAddArr:[],//选择的地址code
            numArr:[]//记录选择的每级地址下标
        }
    },
    props:{
        hospCityArr:Array
    },
    mounted(){
        // console.log(this.hospAddArr)
        this.getCity(this.city,'',0);
    },
    methods:{
        handleChange(value){
            this.hospAddArr=value;
            
            // console.log(this.hospAddArr)
            if(this.numArr.length>=value.length){
                this.numArr.splice(value.length-1,this.numArr.length-value.length+1);
            }
            // console.log(this.numArr)
            if(value.length==1){
                for(let i=0;i<this.city.length;i++){
                    if(this.city[i].value==value[0]){
                        this.numArr[0]=i;
                        this.getCity(this.city[i].cities,value[value.length-1],value.length)
                        break;
                    }        
                }
            }
            else{
                var cityObj=this.city[this.numArr[0]].cities;
                for(let i=1;i<this.numArr.length;i++){
                    cityObj=cityObj[this.numArr[i]].cities;
                }
                console.log(cityObj)
                for(let j=0;j<cityObj.length;j++){
                    if(cityObj[j].value==value[value.length-1]){
                        console.log(j)
                        this.numArr[value.length-1]=j;
                        this.getCity(cityObj[j].cities,value[value.length-1],value.length)
                        break;
                    }        
                }
            }
        },
        //获取地区列表(要填充的数组对象，当前对象的地区code值，要请求的地址级数)
        getCity(cityObj,code,length){
            if(cityObj.length>0){
                return;
            }
            this.$ajax.post(this.$domain.listRegion,{
                code:code,
                level:length+1
            })
            .then(ret=>{
                console.log('获取地址——-------------------')
                console.log(ret.data)
                if(ret.data.code==200){
                    var list=ret.data.data;
                    
                    for(var i=0;i<list.length;i++){
                        
                        if(length>=2){
                            cityObj.push({
                                value:list[i].value,
                                label:list[i].label
                            })
                        }
                        else{
                            cityObj.push({
                                value:list[i].value,
                                label:list[i].label,
                                cities:[]
                            })
                        }
                    }
                }
                else if(ret.data.code==502){
                    this.$message.error('登录失效！请重新登陆');
                    this.$router.push({path:'/login'})
                }
                else if(ret.data.code==201){
                    this.$message.error('已是最后一级，没有下一级了~')
                }
                else{
                    this.$message.error(ret.data.message)
                }
            })
        },
    },
    watch:{
        hospAddArr(val){
            this.$emit('hospAddArr',val)
        },
        hospCityArr(newValue,oldValue){
            this.hospAddArr=newValue
        }
    }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/city.vue